import {inherits} from "util";
import { TradeLines, IOrdersData, IEditRq, MoneyLine, IOrdersHistoryData, TradeClosedRs} from "../../interfaces/service.response";


export interface AccountInformationResponseDTO {

    LogonUserName: string;
    ClientAccountId: number;
    CultureId: number;
    ClientAccountCurrency: string;
    AccountOperatorId: number;
    TradingAccounts: ApiTradingAccountDTO[];
    PersonalEmailAddress: string;
    HasMultipleEmailAddresses: boolean;
    AccountHolders: any;
    ClientTypeId: number;
    LinkedClientAccounts: any;
    IsNfaEnabledClient: boolean;
    IsFifo: boolean;
    DaysUntilExpiryForDemo: number;


}


export interface ApiTradingAccountDTO {
    TradingAccountId: number;
    TradingAccountCode: string;
    TradingAccountStatus: string;
    TradingAccountType: string;
}

export interface ApiMarketDTO {
    MarketId: number;
    Name: string;
    Weighting: number;
}

export interface ChangedData {
    MarketId?: number,
    TickDate?: Date,
    Bid?: number,
    Offer?: number,
    Price?: number
}

export interface PriceTickDTO {
    TickDate: string,
    Price: number
}

export interface GetPriceTickResponseDTO {
    PriceTicks: PriceTickDTO[]
}

export interface GetPriceBarResponseDTO
{
    PriceBars: PriceBarDTO[];
    PartialPriceBar: PriceBarDTO;
    
}

export interface PriceBarDTO
{
    BarDate:string;
    Open:number;
    High:number;
    Low:number;
    Close:number;
    
}

export interface INewTradeOrderRequestDTO
{
    MarketId:number;
    Currency?:string;
    AutoRollover?:boolean;
    Direction:string;
    Quantity:number; 
    QuoteId?:number;
    PositionMethodId?:number;
    BidPrice:number;
    OfferPrice:number;
    AuditId?:string;
    TradingAccountId:number;
    IfDone?:ApiIfDoneDTO[];
    Reference?:string;
    AllocationProfileId?:number;
    OrderReference?:string; //optional
    Source?:string;//optional
    PriceTolerance?:number;
    
}


export class NewTradeOrderRequestDTO implements INewTradeOrderRequestDTO
{
    MarketId:number = 0;
    Currency?:string;
    AutoRollover?:boolean;
    Direction:string = "buy"
    Quantity:number = 0; 
    QuoteId?:number;
    PositionMethodId?:number;
    BidPrice:number = 0;
    OfferPrice:number = 0;
    AuditId?:string;
    TradingAccountId:number = 0;
    IfDone?:ApiIfDoneDTO[] = [];
    Close:number[] = [];
    Reference?:string;
    AllocationProfileId?:number;
    OrderReference?:string; //optional
    Source?:string;//optional
    PriceTolerance?:number;
    
}

export class ApiTradeHistoryDTO
{
    OrderId:number = 0;
    OpeningOrderIds:number[] = [];
    MarketId:number = 0;
    MarketName:string = "";
    Direction:string = "";
    OriginalQuantity?:number;
    Quantity:number = 0;
    Price:number = 0;
    TradingAccountId:number = 0;
    Currency:string = "";
    RealisedPnl:number = 0;
    RealisedPnlCurrency:string = "";
    LastChangedDateTimeUtc:string = "";
    ExecutedDateTimeUtc:string = "";
    TradeReference:string = "";
    ManagedTrades:ApiManagedTradeHistoryDTO[] = [];
    OrderReference:string = "";
    Source:string = "";
    IsCloseBy:boolean = false;
    Liquidation:boolean = false;
    FixedInitialMargin:number = 0;
}

export class ApiManagedTradeHistoryDTO
{
    OrderId:number = 0;
    OpeningOrderIds:number[] = [];
    TradingAccountId:number = 0;
    TradingAccountCode:string = "";
    TradingAccountName:string = "";
    OriginalQuantity?:number;
    Quantity:number = 0;
    RealisedPnl:number = 0;
    RealisedPnlCurrency:string = "";
    LastChangedDateTimeUTC:string = "";
    ExecutedDateTimeUTC:string = "";
}

export class ListTradeHistoryResponseDTO
{
    TradeHistory:ApiTradeHistoryDTO[] = [];
    SupplementalOpenOrders:ApiTradeHistoryDTO[] = [];
}

export class NewStopLimitOrderRequestDTO implements INewTradeOrderRequestDTO
{
    OrderId:number=0;
    MarketId:number=0;
    Currency:string="";
    AutoRollover:boolean=false;
    Direction:string="";
    PositionMethodId:number=0;
    Quantity:number=0;
    BidPrice:number=0;
    OfferPrice:number=0;
    TradingAccountId:number=0;
    IfDone:ApiIfDoneDTO[] = [];
    AuditId:string="";
    OcoOrder?:NewStopLimitOrderRequestDTO;
    Applicability:string="";
    ExpiryDateTimeUTC:string="";
    Guaranteed:boolean=false;
    TriggerPrice:number=0;
    Reference:string="";
    AllocationProfileId:number=0;
    OrderReference:string="";
    Source:string="";
}

export class TradeClosedRsImpl implements TradeClosedRs
{
    FillPrice: number = 0;
    Pips: number = 0;
    Profit: number = 0;
    Qty: number = 0;
    Symbol: string = "";
    Type: string = "TradeClosedRs";


}

export class ApiTradeOrderResponseDTO
{
    Status:number = 0;
    StatusReason:number = 0;
    OrderId:number = 0;
    Orders:ApiOrderResponseDTO[] = [];
    Quote?:ApiQuoteResponseDTO;
    Actions:ApiOrderActionResponseDTO[] = [];
}

export enum OrderStatusCodes{Pending=1, Accepted=2, Open=3, Cancelled=4, Rejected=5, Suspended=6, YellowCard=7, Closed=9, RedCard=10, Triggered=11}

export class ApiOrderResponseDTO
{
    OrderId:number = 0;
    StatusReason:number = 0;
    Status:number = 0;
    OrderTypeId:number = 0;
    Price:number = 0;
    Quantity:number = 0;
    TriggerPrice:number = 0;
    CommissionCharge:number = 0;
    IfDone?:ApiIfDoneResponseDTO;
    GuaranteedPremium:number = 0;
    OCO?:ApiOrderResponseDTO;
    AssociatedOrders?:ApiAssociatedResponseDTO;
    Associated:boolean=false;
}

export class ApiIfDoneResponseDTO
{
    Stop?:ApiOrderResponseDTO;
    Limit?:ApiOrderResponseDTO;
}


export class ApiAssociatedResponseDTO
{
    Stop?:ApiOrderResponseDTO;
    Limit?:ApiOrderResponseDTO;    
}

export class ApiQuoteResponseDTO
{
    QuoteId:number=0;
    Status:number=0;
    StatusReason:number=0;
}



export class ApiIfDoneDTO
{
    Stop?:ApiStopLimitOrderDTO;
    Limit?:ApiStopLimitOrderDTO;
}


export class ApiClientAccountMarginResponseDTO
{
    Cash:number = 0;
    Margin:number = 0;
    MarginIndicator:number = 0;
    NetEquity:number = 0;
    OpenTradeEquity:number = 0;
    TradableFunds:number = 0;
    PendingFunds:number = 0;
    TradingResource:number = 0;
    TotalMarginRequirement:number = 0;
    CurrencyId:number = 0;
    CurrencyIsoCode:string = "";
}

export class ApiOrderActionResponseDTO
{
    ActionedOrderId:number=0;    
    ActioningOrderId:number=0;    
    Quantity:number=0;    
    ProfitAndLoss:number=0;    
    ProfitAndLossCurrency:number=0;    
    OrderActionTypeId:number=0;    
}

export class ApiOrderDTO
{
    OrderId?:number=0;
    Reference?:string;
    OrderReference?:string;
    AutoRollover?:boolean;
    MarketId?:number;
    Direction:string="";
    Quantity:number = 0;
    OriginalQuantity?:number;
    Price?:number;
    OriginalPrice?:number;
    TradingAccountId:number=0;
    CurrencyId?:number;
    StatusId?:OrderStatusCodes;
    TypeId?:OrderTypeId;
    IfDone:ApiIfDoneDTO[] = [];
    OcoOrder?:ApiStopLimitOrderDTO;
    LastChangedDateTimeUTC?:string;
    AssociatedOrders?:ApiAssociatedDTO;
}

export class ApiStopLimitOrderDTO extends ApiOrderDTO
{
    Guaranteed:boolean = false;//true is limit
    TriggerPrice:number = 0;
    ExpiryDateTimeUTC?:string;
    Applicability:string = "gtc";//GTC,GFD,GTD 
    ParentOrderId?:number;
    TrailingDistance?:number;
    Associated?:boolean;
    IsLimitInternal?:boolean;
}


export class ApiAssociatedDTO
{
    Stop?:ApiStopLimitOrderDTO;
    Limit?:ApiStopLimitOrderDTO;
}


export class AccountInfo
{
    Currency:string = "";
    TradingAccountId:number = 0;
}


export class TradeLinesImpl implements TradeLines
{
    Type: string = "TradeLines";
    Lines:OrdersDataImpl[] = [];
    MoneyLine: MoneyLineImpl = new MoneyLineImpl();
    HistoryLines:IOrdersHistoryData[] = [];
    
}

export class OrdersHistoryDataImpl implements IOrdersHistoryData
{
    CloseTime: string = "";
    EntryTime: string = "";    
    Ticket: string = "";
    Type: string = "";
    Qty: string = "";
    Symbol: string = "";
    EntryPrice: string = "";
    Stop: string = "";
    Limit: string = "";
    ClosePrice: string = "";
    Pips: string = "";
    PnLUSD: string ="";
}

export class MoneyLineImpl implements MoneyLine
{
    MarginInUse: number = 0;
    Balance: number = 0;    
    SumOfPips: number = 0;
    SumOfUPLUSD: number = 0;
    SumOfPipsHistory: number = 0;
    SumOfPLUSDHistory: number = 0;
    PnL: number = 0;
    AccountValue: number = 0;

}

export class CloseRs
{
    Type:string="CloseRs";
    Error:string="";
}

export class GetOrderResponseDTO
{
    TradeOrder?:ApiTradeOrderDTO;
    StopLimitOrder?:ApiStopLimitOrderDTO;
}

export class OrdersDataImpl implements IOrdersData
{
    ID: number = 0;
    Symbol: string = "";
    Ticket: string = "";
    EntryTime: string = "";
    Type: string = "";
    Qty: number = 0;
    EntryPrice: number = 0;
    Stop: number = 0;
    Limit: number = 0;
    MarketPrice: number = 0;
    Pips: number = 0;
    PnLUSD: number = 0;
    EditRq: EditRqImpl = new EditRqImpl();
    MenuRequests: string[] = [];
    Trailing: number = 0;
}

export enum OrderType{Pending, Market};

export class EditRqImpl implements IEditRq
{
    Id: number = 0;
    Currency: string = "";    
    LimitPips: number = 0;
    LimitPrice: number = 0;
    Quantity: number = 0;
    Side: string = "";
    StopPips: number = 0;
    StopPrice: number = 0;
    Type: string = "";

    
}

export class ListActiveOrdersResponseDTO
{
    ActiveOrders:ApiActiveOrderDTO[] = [];
}

export enum OrderTypeId{ Trade=1, Stop=2, Limit=3, None = 0 }

export class ApiActiveOrderDTO
{
    TypeId:OrderTypeId=OrderTypeId.None;
    TradeOrder?:ApiTradeOrderDTO;
    StopLimitOrder?:ApiStopLimitOrderDTO;
 
}

export function GetAllConnectedOrders(activeOrder:ApiActiveOrderDTO):ApiStopLimitOrderDTO[]
{
    let res:ApiStopLimitOrderDTO[] = [];
    var order:ApiOrderDTO = new ApiOrderDTO();

    if(activeOrder.TradeOrder)
    {
        order = activeOrder.TradeOrder;
    }
    if(activeOrder.StopLimitOrder)
    {
        order = activeOrder.StopLimitOrder;
    }

    if( order.IfDone )
    {
        order.IfDone.forEach(element => {
            if(element.Limit)
            {
                element.Limit.IsLimitInternal = true;
                res.push(element.Limit);                                            
            }
            if(element.Stop)
            {
                element.Stop.IsLimitInternal = false;
                res.push(element.Stop);                                            
            }                
        });
        
    } 

    if( order.AssociatedOrders )
    {
        if(order.AssociatedOrders.Limit)
        {
            order.AssociatedOrders.Limit.IsLimitInternal = true;
            res.push(order.AssociatedOrders.Limit);                                            
        }
        if(order.AssociatedOrders.Stop)
        {
            order.AssociatedOrders.Stop.IsLimitInternal = false;
            res.push(order.AssociatedOrders.Stop);                                            
        }                            
    } 


    return res;
}

export class ApiTradeOrderDTO extends ApiOrderDTO
{
    ManagedTrades?:ApiManagedTradeDTO[];
    CreatedDateTimeUTC:string="";
}

export class ApiManagedTradeDTO
{
    OrderId:number=0;
    Quantity:number=0;
    TradingAccountId:number=0;
    TradingAccountCode:string="";
    TradingAccountName:string="";
    LastChangedDateTimeUTC:string="";
}

export class SwitchAccountRs
{
    Type:string = "SwitchAccountRs";
    ActiveAccount:AccountRs = new AccountRs();
}

export class AccountRs
{
    Id:number=0;
}

export class ListActiveOrdersRequestDTO
{
    TradingAccountId:number = 0;
    MaxResults:number = 0;
}

/*
export class MoneyLine
{
    Balance:number=0;
    AccountValue:number=0;
    MarginInUse:number=0;
    SumOfPips:number=0;
    SumOfUPLUSD:number=0;
    SumOfPipsHistory:number=0;
    SumOfPLUSDHistory:number=0;
    PnL:number=0;
    
}

export class TradeLine
{
    Symbol:string="";
    Ticket:string="";
    EntryTime:string="";
    Type:string="";
    Qty:string="";
    EntryPrice:string="";
    Stop:string="";
    Limit:string="";
    Trailing:string="";
    MarketPrice:string="";
    Pips:string="";
    PnLUSD:string="";
    EditRq:EditRq = new EditRq();
    MenuRequests:string[]=[];
    
}

export class EditRq
{
    Id:string="";
    Type:string="";
    Currency:string="";
    EnterPrice:number=0;
    Quantity:number=0;
    Side:string = "";
    StopPrice:number=0;
    StopPips:number=0;
    LimitPrice:number=0;
    LimitPips:number=0;
    TrailingStopPips:number=0;
    
}
*/

export class CancelOrderRequestDTO
{
    OrderId:number = 0;
    TradingAccountId:number = 0;
    Reference:string = "";
}

export class HistoryLine
{
    Symbol:string="";
    Ticket:string="";
    EntryTime:string="";
    CloseTime:string="";
    Type:string="";
    Qty:string="";
    EntryPrice:string="";
    Stop:string="";
    Limit:string="";
    ClosePrice:string="";
    Pips:string="";
    PnLUSD:string="";
    
}




export function GetGainOrderStatusReasons():string[]
{
    var statusReasons:string[] = [];
    statusReasons[1]="OK.";
    statusReasons[2]="This Market does not currently allow guaranteed orders.";
    statusReasons[3]="This Market is currently not available on the Trading Platform.";
    statusReasons[4]="Limit Down.";
    statusReasons[5]="Limit Up.";
    statusReasons[6]="Oversize.";
    statusReasons[7]="Oversize.";
    statusReasons[8]="Below the minimum quantity.";
    statusReasons[9]="This Market has expired.";
    statusReasons[10]="Market Closed.";
    statusReasons[11]="Market is Phone Only.";
    statusReasons[12]="The Quantity, when divided by the market lot size, should be a whole number.";
    statusReasons[13]="Market Suspended.";
    statusReasons[14]="Trades on this market can not have linked Stop and/or Limit orders.";
    statusReasons[15]="Market does not allow Stop orders.";
    statusReasons[16]="Market does not allow orders to trigger against Our Price.";
    statusReasons[17]="Market type must be Binary or Spread Bet.";
    statusReasons[18]="Market is currently set to not trade on the web.";
    statusReasons[19]="Market GTD Order Exposure Exceeded.";
    statusReasons[20]="The Quantity decimal places exceed the maximum allowed for the market.";
    statusReasons[21]="The expiry date/time should not be set with Good Till Cancelled orders.";
    statusReasons[22]="A Guaranteed Stop Loss order must always be set to Good Till Cancelled.";
    statusReasons[23]="A Guaranteed order cannot be a Limit order.";
    statusReasons[24]="Stop Loss order must be guaranteed.";
    statusReasons[25]="Trigger price is not correct given the order direction and type.";
    statusReasons[26]="Order must be set to trigger against Our Price.";
    statusReasons[27]="Oversize trade for Binary market.";
    statusReasons[28]="When the order Quantity is within our size, the target type must be set to Our Price.";
    statusReasons[29]="This Market is set to not allow clients to place trades.";
    statusReasons[30]="Cannot open a new short position as the market is currently set to Long Only.";
    statusReasons[31]="This account is not allowed to trade in the supplied currency.";
    statusReasons[32]="This account is currently suspended.";
    statusReasons[33]="This account is not open.";
    statusReasons[34]="Cannot place guaranteed stop order.";
    statusReasons[35]="The Quantity is below the minimum allowed for the Trading Academy account.";
    statusReasons[36]="Cannot accept order that is not on yellow card.";
    statusReasons[37]="Cannot amend trade or order that is not active.";
    statusReasons[38]="Cannot trigger this order as it is not active.";
    statusReasons[39]="Cannot reset order that has not triggered.";
    statusReasons[40]="An Order in an If Done relationship must be of type trade.";
    statusReasons[41]="An Order in an If Done relationship must be of type stop or limit.";
    statusReasons[42]="Orders in an OCO relationship must be of type stop or limit.";
    statusReasons[43]="The order currency must match the currency of the underlying.";
    statusReasons[44]="The Market does not allow limited risk guaranteed orders to be placed.";
    statusReasons[45]="A Guaranteed Order cannot be set to trigger against external price.";
    statusReasons[46]="Orders in a closing stop/limit relationship must have opposing directions.";
    statusReasons[47]="Cannot trade against market that has a bet per of zero.";
    statusReasons[48]="A Linked order in an If Done relationship must have an amount less than or equal to the original order.";
    statusReasons[49]="Trigger level does not conform to minimum distance requirements specified for the market.";
    statusReasons[50]="Cannot close trade with triggered order.";
    statusReasons[51]="Cannot fill this order as it is not active.";
    statusReasons[52]="Cannot amend order that is not active.";
    statusReasons[53]="Unable to calculate equity CFD commission due to missing or incorrect settings.";
    statusReasons[54]="Order cannot be linked to other orders for the same link type.";
    statusReasons[55]="Unable to calculate the guaranteed order premium due to missing or incorrect settings.";
    statusReasons[56]="The Market must be of type: Binary.";
    statusReasons[57]="All orders must be associated with the same trading account.";
    statusReasons[58]="Trade to close is no longer open.";
    statusReasons[59]="Speed Bump.";
    statusReasons[60]="The Market must be of type: Cash.";
    statusReasons[61]="The bid/offer price entered does not overlap the current bid/offer price.";
    statusReasons[62]="The bid/offer price entered is not valid within the last three seconds.";
    statusReasons[63]="Insufficient Funds.";
    statusReasons[64]="The Market underlying currency is not supported by the trading account.";
    statusReasons[65]="The Market must be of type: CFD.";
    statusReasons[66]="Unable to add guaranteed stop loss order as the market does not have the necessary settings.";
    statusReasons[67]="Supplied price is in an indicative state.";
    statusReasons[68]="Supplied price is in an unavailable state.";
    statusReasons[69]="The Clients account is currently suspended.";
    statusReasons[70]="This Market does not allow orders to be linked in an OCO relationship.";
    statusReasons[71]="This Market does not allow limit orders.";
    statusReasons[72]="This Market does not allow orders to trigger against external price.";
    statusReasons[73]="The total quantity of linked stop orders must not exceed opening order quantity.";
    statusReasons[74]="The total quantity of linked limit orders must not exceed opening order quantity.";
    statusReasons[75]="The total quantity of guaranteed stop orders must be equal to trade order quantity.";
    statusReasons[76]="New position cannot be opened as the market is set to Close only.";
    statusReasons[77]="Cannot create new position when closing specific order serial number(s).";
    statusReasons[78]="The Total Margin Requirement limit has been exceeded.";
    statusReasons[79]="The quantity will cause the account to exceed the market maximum limited risk order exposure.";
    statusReasons[80]="The order target is set to trigger off the external price but the market prices out of hours.";
    statusReasons[81]="Position below Web Min Size.";
    statusReasons[82]="The trigger price is not valid for the market pricing rules.";
    statusReasons[83]="The bid price is not valid for the market pricing rules.";
    statusReasons[84]="Insufficient Funds.";
    statusReasons[85]="Insufficient Funds.";
    statusReasons[86]="Insufficient Funds.";
    statusReasons[87]="Insufficient Funds.";
    statusReasons[88]="Order has passed expired date/time.";
    statusReasons[89]="Insufficient Funds.";
    statusReasons[90]="Closing Price Used For Margin.";
    statusReasons[91]="Closing Price Used For Margin.";
    statusReasons[92]="ALERT! OBMS has triggered order as it was being loaded.";
    statusReasons[93]="Closing Price Used For Margin.";
    statusReasons[94]="Closing Price Used For Margin.";
    statusReasons[95]="The offer price is not valid for the market pricing rules.";
    statusReasons[96]="The expiry date/time should be provided with Good Till Date orders.";
    statusReasons[97]="Closing Price Used For Margin.";
    statusReasons[98]="Closing Price Used For Margin.";
    statusReasons[99]="Closing Price Used For Margin.";
    statusReasons[100]="Another order has closed trade.";
    statusReasons[101]="Cancelled by client.";
    statusReasons[102]="Order has been rejected.";
    statusReasons[103]="Other OCO order has filled.";
    statusReasons[104]="The trade was placed against the wrong trading account.";
    statusReasons[105]="The trade was placed at an incorrect price.";
    statusReasons[106]="The trade was placed against the wrong market.";
    statusReasons[107]="The trade was placed twice.";
    statusReasons[108]="The trade was placed with an incorrect quantity.";
    statusReasons[109]="The expiry date/time should not be provided with Good For Day orders.";
    statusReasons[110]="The Guaranteed order must always be set to trigger out of hours.";
    statusReasons[111]="The Guaranteed order quantity cannot be increased.";
    statusReasons[112]="The expiry date/time cannot be changed if order is Good For Day.";
    statusReasons[113]="Cannot cancel a guaranteed stop loss order on a Limited Risk trade.";
    statusReasons[114]="The order status must be set to one of the following: Triggered; Yellow Card.";
    statusReasons[115]="Unable to calculate non-equity CFD commission due to missing or incorrect settings.";
    statusReasons[116]="Dealer has triggered order.";
    statusReasons[117]="Unable to determine a price when performing margin simulation for this instruction.";
    statusReasons[118]="Unable to determine a price when performing margin simulation for this instruction.";
    statusReasons[119]="Unable to determine a price when performing margin simulation for this instruction.";
    statusReasons[120]="Unable to determine a price when performing margin simulation for this instruction.";
    statusReasons[121]="Unable to determine a price when performing margin simulation for this instruction.";
    statusReasons[122]="Unable to determine a price when performing margin simulation for this instruction.";
    statusReasons[123]="Unable to determine a price when performing margin simulation for this instruction.";
    statusReasons[124]="DMA Error.";
    statusReasons[125]="Total Margin Requirement Limit has been exceeded.";
    statusReasons[126]="Total Margin Requirement Limit has been exceeded.";
    statusReasons[127]="Total Margin Requirement Limit has been exceeded.";
    statusReasons[128]="Total Margin Requirement Limit has been exceeded.";
    statusReasons[129]="Total Margin Requirement Limit has been exceeded.";
    statusReasons[130]="A broker is not allowed to trade against this market via the client trade ticket.";
    statusReasons[131]="This account is not allowed to trade against this market via the hedge ticket.";
    statusReasons[132]="Referral Spread.";
    statusReasons[133]="This Market does not support the trading client type.";
    statusReasons[134]="OCO link can only be between the following order pairs: Buy Limit/Stop; Buy/Sell Limit; Sell Limit/Stop; Buy/Sell Stop.";
    statusReasons[135]="Account academy status cannot be set to New Account.";
    statusReasons[136]="Market rollover date has passed.";
    statusReasons[137]="Market last trading date has passed.";
    statusReasons[138]="Quantity exceeds the maximum allowed for the market.";
    statusReasons[139]="Market expiry has passed.";
    statusReasons[140]="Watch List Client.";
    statusReasons[141]="Watch List Client.";
    statusReasons[142]="Client is currently not allowed to accept new business.";
    statusReasons[143]="Client is currently not allowed online access.";
    statusReasons[144]="Client is currently not allowed to trade online.";
    statusReasons[145]="Account is currently not allowed to accept new business.";
    statusReasons[146]="Account is currently not allowed online access.";
    statusReasons[147]="Account is currently not allowed to trade online.";
    statusReasons[148]="Gap Tolerance Exceeded.";
    statusReasons[149]="Cannot close existing positions on different books.";
    statusReasons[150]="Trigger prices of orders in If Done link must be valid.";
    statusReasons[151]="Market Quote Order.";
    statusReasons[152]="Order(s) for same account/market must be approved in the order they triggered.";
    statusReasons[153]="ALERT! OBMS has triggered order at different level to current.";
    statusReasons[154]="Other OCO order has been rejected.";
    statusReasons[155]="ALERT! OBMS has triggered order due to problem filling it.";
    statusReasons[156]="Cannot reject order that has not triggered.";
    statusReasons[157]="Auto Closeout.";
    statusReasons[158]="Price tolerance exceeded.";
    statusReasons[159]="We are unable to process this request due to a failed Customer Knowledge Assessment, please contact Customer Services.";
    statusReasons[160]="Market unavailable due to local regulations or account restrictions.";
    statusReasons[161]="Order structure is not supported for MetaTrader enabled accounts.";
    statusReasons[162]="Order quantity is not a valid increment size.";
    statusReasons[163]="Unable to calculate FX commission due to missing or incorrect settings.";
    statusReasons[164]="Unable to calculate CFD commission due to missing or incorrect settings.";
    statusReasons[165]="No managed accounts in allocation profile.";
    statusReasons[166]="Bad market increment size setting.";
    statusReasons[167]="An existing managed trade allocation is required.";
    statusReasons[168]="All managed trades resulted in red cards.";
    statusReasons[169]="Watch List Client.";
    statusReasons[170]="Watch List Client.";
    statusReasons[171]="Unable to calculate US Dollar Notional commission due to missing or incorrect arguments.";
    statusReasons[172]="Cannot place associated order with no net position.";
    statusReasons[173]="Cannot modify position with triggered associated order.";
    statusReasons[174]="Max Position Exceeded.";
    statusReasons[175]="US Standard Lot settings are missing.";
    statusReasons[176]="Underlying step margin settings could not be resolved.";
    statusReasons[177]="Market is DMA.";
    return statusReasons;
}

export class PipsUPL
{
  Pips:number = 0;
  UPL:number= 0;
}

export class UpdateTradeOrderRequestDTO extends NewTradeOrderRequestDTO
{
    OrderId:number=0;
    CloseByOrderId?:number;
}

